import { all, put, call, select, takeEvery } from 'redux-saga/effects'
import { getLeftMenuData, getTopMenuData } from 'services/virtual/menu'
import { getMenu } from 'services/virtual/setup'
// import eventActions from 'redux/virtual/event/actions'
import actions from './actions'

export function* GET_DATA() {
  const state = yield select()
  const {
    virtualUser: { roles },
  } = state
  let navigationData = []
  const result = yield call(getMenu)
  if (result.status === 200) {
    navigationData = result.data
    // yield put({
    //   type: eventActions.SET_STATE,
    //   payload: {
    //     navigation: result.data
    //   }

    // })
  }
  const isExhibitor = roles.includes('ROLE_EXHIBITOR')
  const menuLeftData = yield call(getLeftMenuData)
  const menuTopData = yield call(getTopMenuData, navigationData, isExhibitor)
  yield put({
    type: actions.SET_STATE,
    payload: {
      menuLeftData,
      menuTopData,
    },
  })
}

export function* GET_INITIAL_DATA() {
  const menuLeftData = yield call(getLeftMenuData)
  const menuTopData = yield call(getTopMenuData, '', false)
  yield put({
    type: actions.SET_STATE,
    payload: {
      menuLeftData,
      menuTopData,
    },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_DATA, GET_DATA), GET_INITIAL_DATA()])
}
